module.exports = __webpack_public_path__ + "media/images/athletes/1454-ad324c9951953b6eede9d00720dbf565.png";